const grJSON = {
  // General
  Open: 'Άνοιγμα',
  Close: 'Κλείσιμο',
  'Go to next page': 'Επόμενη σελίδα',
  'Go to previous page': 'Προηγούμενη σελίδα',
  'Rows per page': 'Σειρές ανά σελίδα',
  of: 'από',
  OR: 'Ή',
  'Something went wrong': 'Κάτι δεν πήγε καλά',
  // Status pages
  "The page you were looking for doesn't exist.":
    'Η σελίδα που αναζητήσατε δεν υπάρχει',
  "It's on us, we moved the content to a different page. The search below should help!":
    'Έχουμε μετακινήσει το περιεχόμενο που ψάχνετε σε άλλη σελίδα. Χρησιμοποιήστε την αναζήτηση!',
  Search: 'Αναζήτηση',
  'Search terms here...': 'Αναζήτηση όρων εδώ..',
  'Go to homepage': 'Αρχική σελίδα',
  'You do not have permission to access this page':
    'Δεν έχετε άδεια πρόσβασης σε αυτή τη σελίδα',
  'Please contact the Compair administrator to give you the appropriate permissions or sign in again with the correct account.':
    'Παρακαλούμε επικοινωνήστε με τον διαχειριστή του COMPAIR ώστε να σας δώσει πρόσβαση ή συνδεθείτε ξανά με κατάλληλο λογαριασμό.',
  'Return to homepage': 'Επιστροφή στην αρχική σελίδα',
  Unauthorized: 'Χωρίς εξουσιοδότηση',
  // Homepage
  'Together we can achieve clean air for all':
    'Μαζί μπορούμε να επιτύχουμε καθαρό αέρα για όλους',
  'Join COMPAIR and participate in measuring and reviewing air quality against other city data sources.':
    'Με την συμμετοχή σας στο COMPAIR θα συνεισφέρετε στην μέτρηση της ποιότητας αέρα',
  'Learn more': 'Μάθετε περισσότερα',
  'What We Offer': 'Τι προσφέρουμε',
  'Easy to understand Interactive Dashboards':
    'Εύχρηστα διαδραστικά Dashboards',
  'A cool new way to visualise and explore potential (urban) solutions quickly and effectively':
    'Έναν μοντέρνο τρόπο απεικόνισης και μελέτης αστικών λύσεων γρήγορο και αποδοτικό',
  'Dynamic Exposure Visualisation Application':
    'Εφαρμογή Dynamic Exposure Visualisation',    
  'Dynamic Exposure Visualisation':'Οπτικοποίηση δυναμικής έκθεσης',
  'Dynamic Exposure Visualisation Dashboard': 'Πίνακας εργαλείων οπτικοποίησης δυναμικής έκθεσης',
  'Learn how airborne pollutants, including fine dust, vary along routes taken by different modes of travel.': 'Μάθετε πως οι αέριοι ρύποι, συμπεριλαμβανομένης της σκόνης, κατανέμονται σε διαδρομές ανάλογα με τον τρόπο μετάκίνησης',
  'A better understanding of the local issues in order to be more collaborative and creative in coming up with solutions':
    'Καλύτερη κατανόηση των τοπικών θεμάτων ώστε να προκύπτουν λύσεις συνεργατικές και δημιουργικές',
  'Try COMPAIR Tools': 'Δοκιμάστε τα εργαλεία του COMPAIR',
  'Making Data More Accessible, click through our offerings and try them for free.':
    'Προσφέρουμε εργαλεία που κάνουν τα δεδομένα προσβάσιμα, επιλέξτε εδώ για να τα δοκιμάσετε',
  'DEVA Application': 'DEVA εφαρμογή',
  'Understand and compare how environmental situations change under different actions':
    'Κατανοήστε και συγκρίνετε πως οι περιβαλλοντικές συνθήκες μεταβάλλονται με συγκεκριμένες δράσεις',
  'See how you can affect your carbon footprint through your daily activities and learn how you can reduce your carbon footprint':
    'Ανακαλύψτε πως οι καθημερινές σας συνήθειες επηρεάζουν το αποτύπωμα άνθρακα και μάθετε πως να το μειώσετε',
  'Explore your surroundings via your smartphone or tablet camera, so you can see a visual overlay of environmental information':
    'Εξερευνήστε το περιβάλλον σας μέσω της κάμερας του smartphone ή του tablet σας, ώστε να μπορείτε να δείτε οπτικοποιημένες περιβαλλοντικές πληροφοριες',
  'Lets Be More Aware of Individual Actions and Behaviours':
    'Ας έχουμε περισσότερη επίγνωση των ατομικών ενεργειών και συμπεριφορών μας ',
  'Use our dashboards and learn what needs to be done at a personal, local and city-wide level to improve air quality':
    'Χρησιμοποιήστε το dashboard και μάθετε τι πρέπει να κάνετε σε προσωπικό, τοπικό και σε επίπεδο πόλης για τη βελτίωση της ποιότητας του αέρα',
  'Explore results via an easy app and generate ideas for change':
    'Εξερευνήστε τα αποτελέσματα μέσω μιας εύκολης εφαρμογής και εκφράστε ιδέες για αλλαγή',
  'Raise awareness about local issues in your community and take part in our experiments':
    'Αυξήστε την ευαισθητοποίηση σχετικά με ζητήματα σε τοπικό επίπεδο και λάβετε μέρος στα πειράματά μας',
  // Theme settings
  'Theme Settings': 'Ρυθμίσεις θέματος ',
  'Light mode': 'Λειτουργία φωτός ',
  'Pure Light': 'Απαλό φως',
  'Dark mode': 'Σκούρο φως ',
  'Dark Spaces': 'Σκοτεινά τμήματα',
  // Navigation bar
  'Compair Dashboard': 'Compair Dashboard',
  Admin: 'Διαχειριστής ',
  User: 'Χρήστης ',
  Guest: 'Επισκέπτης',
  General: 'Γενικά ',
  Home: 'Αρχική σελίδα',
  Dashboards: 'Dashboards',
  'Policy Monitoring': 'Παρακολούθηση πολιτικών ',
  'Browse the map': 'Περιήγηση στον χάρτη',
  'Carbon Footprint': 'Αποτύπωμα άνθρακα',
  Management: 'Διαχείριση',
  'User Management': 'Διαχείριση χρηστών',
  // User management
  'All aspects related to the app users can be managed from this page':
    'Μπορείτε να διαχειριστείτε όλες τις παραμέτρους που σχετίζονται με τους χρήστες αυτής  της εφαρμογής μέσα από αυτήν τη σελίδα',
  'Create user': 'Δημιουργία χρήστη',
  'Add new user': 'Προσθήκη νέου χρήστη ',
  'Fill in the fields below to create and add a new user to the site':
    'Συμπληρώσε τα πεδία παρακάτω για να δημιουργήσετε και να προσθέσετε νέο χρήστη',
  'First name': 'Όνομα ',
  'The first name field is required': 'Το πεδίο είναι υποχρεωτικό ',
  'Last name': 'Επίθετο',
  'The last name field is required': 'Το πεδίο είναι υποχρεωτικό ',
  'Email address': 'Email',
  'The email field is required': 'Το πεδίο είναι υποχρεωτικό ',
  'The email provided should be a valid email address':
    'Το email πρέπει να είναι έγκυρο',
  Password: 'Κωδικός Πρόσβασης',
  'The password field is required': 'Το πεδίο είναι υποχρεωτικό ',
  'Must be at least 8 characters':
    'Πρέπει να περιλαμβάνει τουλαχιστον 8 χαρακτήρες ',
  Administrator: 'Διαχειριστής ',
  Cancel: 'Ακύρωση',
  'All users': 'Ολοι οι χρήστες ',
  Administrators: 'Διαχειριστές',
  Users: 'Χρήστες',
  'Search by name, email or username...':
    'Αναζήτηση με όνομα, email ή όνομα χρήστη',
  Name: 'Όνομα',
  Email: 'Email',
  Role: 'Ρόλος',
  'Bulk actions': 'Μαζικές ενέργειες',
  Delete: 'Διαγραφή ',
  'Are you sure you want to permanently delete this user account':
    'Είστε σιγουροι ότι θέλετε να διαγράψετε οριστικά αυτό τον χρήστη',
  'The user account has been removed': 'Ο λογαριασμός χρήστη διαγράφηκε',
  'The user account was created successfully':
    'Ο λογαριασμός χρήστη δημιουργήθηκε επιτυχώς ',
  "We couldn't find any users matching your search criteria":
    'Δεν μπορέσαμε να βρούμε χρήστες που να πληρούν τα κριτήρια αναζήτησής σας',
  Edit: 'Επεξεργασία ',
  'Update user': 'Ενημέρωση χρήστη',
  'My Profile': 'Το προφίλ μου',
  'Manage informations related to your profile settings':
    'Διαχειριστείτε πληροφορίες που σχετίζονται με τις ρυθμίσεις του προφίλ σας',
  'Personal Details': 'Προσωπικά στοιχεία',
  'Manage informations related to your personal details':
    'Διαχειριστείτε πληροφορίες που σχετίζονται με τα προσωπικά σας στοιχεία',
  'Update profile': 'Ανανέωση προφίλ ',
  'Your profile was updated successfully': 'Το προφίλ σας ανανεώθηκε επιτυχώς ',
  Security: 'Ασφάλεια ',
  'Change your security preferences below':
    'Αλλάξτε τις προτιμήσεις ασφαλείας σας παρακάτω',
  'Change Password': 'Αλλαγή κωδικού πρόσβασης ',
  'You can change your password here':
    'Μπορείτε να αλλάξετε τον κωδικό πρόσβασής σας εδώ',
  'Change password': 'Αλλαγή κωδικού πρόσβασης ',
  'Fill in the fields below to change your password':
    'Συμπληρώστε τα παρακάτω πεδία για να αλλάξετε τον κωδικό πρόσβασής σας',
  'Current password': 'Τρέχων κωδικός πρόσβασης ',
  'New password': 'Νέος κωδικός πρόσβασης',
  'New password is required': 'Απαιτείται νέος κωδικός πρόσβασης ',
  'Confirm new password': 'Επιβεβαίωση κωδικού πρόσβασης ',
  'Confirm password is required': 'Απαιτείται επιβεβαίωση κωδικού πρόσβασης',
  'Current password is required': 'Απαιτείται ο τρέχων κωδικός πρόσβασης',
  'New password must be at least 8 characters':
    'Ο νέος κωδικός πρόσβασης πρέπει να περιλαμβάνει τουλάχιστον 8 χαρακτήρες ',
  'Passwords do not match': 'Οι δύο κωδικοί δεν είναι ίδιοι',
  'Update password': 'Ενημέρωση κωδικού πρόσβασης',
  // Top navigation bar
  'My profile': 'Το προφίλ μου',
  'Log in to view your details': 'Συνδεθείτε για να δείτε τα στοιχεία σας',
  'Language Switcher': 'Αλλαγή γλώσσας',
  // Authentication
  'Sign out': 'Αποσύνδεση',
  'Sign in': 'Σύνδεση',
  'Fill in the fields below to sign into your account.':
    'Συμπληρώστε τα παρακάτω πεδία για να συνδεθείτε στο λογαριασμό σας.',
  'Lost password?': 'Έχασες τον κωδικό σου?',
  'Username or password is incorrect':
    'Ο κωδικός πρόσβασης ή το όνομα χρήστη είναι λάθος',
  'Don’t have an account, yet?': 'Δεν έχετε ακόμη λογαριασμό?',
  'Sign up here': 'Εγγραφή',
  'Recover Password': 'Ανάκτηση κωδικού πρόσβασης',
  'Enter the email used for registration to reset your password.':
    'Εισάγετε το email που χρησιμοποιήσατε κατα την εγγραφή σας για να επαναφέρετε τον κωδικό πρόσβασής σας.',
  'Send me a new password': 'Αποστολή Νέου κωδικού',
  'Want to try to sign in again?': 'Θέλετε να προσπαθήσετε να ξανασυνδεθείτε?',
  'Click here': 'Πάτησε εδώ',
  'Create account': 'Δημιουργία λογαριασμού',
  'Fill in the fields below to sign up for an account.':
    'Συμπληρώστε τα παρακάτω πεδία για να εγγραφείτε.',
  'Password must be at least 8 characters':
    'Ο κωδικός πρόσβασης πρέπει να περιλαμβάνει τουλάχιστον 8 χαρακτήρες',
  'Both password need to be the same':
    'Παρακαλώ χρησιμοποιήστε τον ίδιο κωδικό πρόσβασης',
  'You must agree to our terms and conditions':
    'Θα πρέπει να συμφωνήσετε με τους όρους κ τις προυποθέσεις',
  'Create your account': 'Δημιούργησε τον λογαριασμό σου',
  'Already have an account?': 'Έχεις ήδη λογαριασμό?',
  'Sign in here': 'Εγγραφείτε εδώ',
  'You have successfully signed up to Compair. Sign in below to continue':
    'Έχετε εγγραφεί επιτυχώς στο Compair. Συνδεθείτε παρακάτω για να συνεχίσετε',
  'Confirm password': 'Επαλήθευση κωδικού',
  'I accept the': 'Αποδοχή',
  'terms and conditions': 'Όροι και Προϋποθέσεις',
  // Footer
  'by COMPAIR Project': 'από το έργο COMPAIR',
  "This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No 101036563. This website represents the views of the COMPAIR project only.":
    'Το έργο αυτό χρηματοδοτήθηκε από το πρόγραμμα έρευνας και καινοτομίας "Ορίζοντας 2020" της Ευρωπαϊκής Ένωσης στο πλαίσιο της συμφωνίας επιχορήγησης με αριθ. 101036563. Ο παρών δικτυακός τόπος αντιπροσωπεύει μόνο τις απόψεις του έργου COMPAIR.',
  'Terms & Conditions': 'Όροι και Προϋποθέσεις',
  'Privacy Policy': 'Πολιτική Απορρήτου',
};

export default grJSON;
